<template>
  <div>
    <v-layout>
      <v-flex xs1>
        <v-img
          flat
          src="https://cdn.blueticket.com.br/assets/icons/Money.svg"
          width="24"
        ></v-img>
      </v-flex>
      <v-flex>
        <confirmation-billet v-if="paymentOption === 'BB'" />
        <confirmation-card v-if="paymentOption === 'CC'" />
        <confirmation-courtesy v-if="paymentOption === 'D'" />
        <confirmation-ame v-if="paymentOption === 'AME'" />
        <confirmation-pix v-if="paymentOption === 'PIX'" />
        <confirmation-paypal
          v-if="paymentOption === 'PP' || paymentOption === 'PPE'"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import ConfirmationBillet from './ConfirmationBillet';
import ConfirmationCard from './ConfirmationCard';
import ConfirmationCourtesy from './ConfirmationCourtesy';
import ConfirmationAme from './ConfirmationAme';
import ConfirmationPaypal from './ConfirmationPaypal';
import ConfirmationPix from './ConfirmationPix.vue';

export default {
  components: {
    ConfirmationBillet,
    ConfirmationCard,
    ConfirmationCourtesy,
    ConfirmationAme,
    ConfirmationPaypal,
    ConfirmationPix,
  },
  computed: {
    paymentOption() {
      return this.$store.getters.paymentOption;
    },
  },
};
</script>
